var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#07B6D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8355_18290)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4498 5.49998C7.03559 5.49998 6.6998 5.83576 6.6998 6.24998V13.75C6.6998 14.1642 7.03559 14.5 7.4498 14.5H9.5498C9.79833 14.5 9.9998 14.7014 9.9998 14.95C9.9998 15.1985 9.79833 15.4 9.5498 15.4H7.4498C6.53854 15.4 5.7998 14.6612 5.7998 13.75V6.24998C5.7998 5.33871 6.53853 4.59998 7.4498 4.59998H10.7498C10.8692 4.59998 10.9836 4.64739 11.068 4.73178L14.068 7.73178C14.1524 7.81617 14.1998 7.93063 14.1998 8.04998V9.54998C14.1998 9.7985 13.9983 9.99998 13.7498 9.99998C13.5013 9.99998 13.2998 9.7985 13.2998 9.54998V8.49998H10.7498C10.5013 8.49998 10.2998 8.2985 10.2998 8.04998V5.49998H7.4498ZM11.1998 6.13637L12.6634 7.59998H11.1998V6.13637ZM15.8588 11.9228C16.0395 12.0935 16.0476 12.3783 15.877 12.559L13.327 15.259C13.2407 15.3503 13.1201 15.4015 12.9944 15.3999C12.8687 15.3984 12.7494 15.3444 12.6653 15.251L11.3153 13.751C11.1491 13.5663 11.164 13.2817 11.3488 13.1155C11.5335 12.9492 11.818 12.9642 11.9843 13.1489L13.0078 14.2862L15.2226 11.941C15.3933 11.7603 15.6781 11.7522 15.8588 11.9228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8355_18290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoIcon);
export default __webpack_public_path__ + "static/media/todo-icon.141c0be71e9c23a96adf22a9589d5496.svg";
export { ForwardRef as ReactComponent };